import {Icon} from "../../../../../../../elements";
import {InputWrapper, InputField, SearchIcon} from "./SearchInput.styled";

export const SearchInput = ({ value, onChange }) => {
  const onHandleChange = (e) => {
    onChange && onChange(e.target.value);
  }

  return (
    <InputWrapper>
      <SearchIcon>
        <Icon name={"magnifier"} height={'20px'} width={'20px'}></Icon>
      </SearchIcon>
      <InputField value={value} type="text" placeholder="Search" onChange={onHandleChange} />
    </InputWrapper>
  );
}
